// Habillage COMMUN des deux écrans d'authentification (connexion, réinitialisation).
// ⚠️ Écrit ici plutôt que dans chaque écran : ce sont les deux seules pages du back-office rendues HORS
// coquille, elles doivent se ressembler exactement — un écart de gouttière ou de couleur entre elles se
// lit comme un changement de site au moment le plus sensible du parcours.
// ⚠️ Tout vient des JETONS de la charte (@orgazone/ui-tokens, montés par <ThemeVars/>) : aucune couleur
// en dur, donc le thème clair/sombre suit tout seul.

import type { CSSProperties } from 'react';

export const ecran: CSSProperties = {
  minHeight: '100%', display: 'grid', placeItems: 'center', background: 'var(--canvas)', padding: 20,
};

export const carte: CSSProperties = {
  width: 400, maxWidth: '100%', background: 'var(--paper)', border: '1px solid var(--ink-200)',
  borderRadius: 'var(--r-lg)', padding: 30,
};

export const eyebrow: CSSProperties = {
  fontSize: 'var(--t-sub)', fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase',
  color: 'var(--teal-500)',
};

export const heading: CSSProperties = { fontSize: 'var(--t-h2)', fontWeight: 800, color: 'var(--ink-900)', marginTop: 2 };

export const label: CSSProperties = {
  fontSize: 'var(--t-body)', fontWeight: 600, color: 'var(--ink-500)', display: 'block', marginBottom: 6,
};

export const champ: CSSProperties = {
  width: '100%', height: 44, padding: '0 13px', borderRadius: 'var(--r-sm)',
  border: '1px solid var(--ink-200)', background: 'var(--canvas)', color: 'var(--ink-900)',
  fontSize: 'var(--t-control)',
};

/** Échec : ce qui a été refusé, ou ce qui n'a pas pu être demandé. */
export const bandeauErr: CSSProperties = {
  background: 'var(--rose-bg)', border: '1px solid var(--rose-fg)', color: 'var(--rose-fg)',
  borderRadius: 'var(--r-sm)', padding: '11px 13px', fontSize: 'var(--t-body)', lineHeight: 1.45,
  marginBottom: 18,
};

/** Avertissement : le service fonctionne, mais pas comme d'habitude (mode dégradé, portée restreinte). */
export const bandeauAvert: CSSProperties = {
  background: 'var(--amber-bg)', border: '1px solid var(--amber-fg)', color: 'var(--amber-fg)',
  borderRadius: 'var(--r-sm)', padding: '11px 13px', fontSize: 'var(--t-body)', lineHeight: 1.45,
  marginBottom: 18,
};

/** Confirmation SOBRE : elle ne doit jamais affirmer plus que ce que le serveur a dit. */
export const bandeauOk: CSSProperties = {
  background: 'var(--ok-bg)', border: '1px solid var(--ok)', color: 'var(--ok-fg)',
  borderRadius: 'var(--r-sm)', padding: '13px 15px', fontSize: 'var(--t-body)', lineHeight: 1.5,
};

export const note: CSSProperties = {
  textAlign: 'center', fontSize: 'var(--t-dense)', color: 'var(--ink-400)', lineHeight: 1.5, margin: 0,
};

export const lienAccent: CSSProperties = {
  display: 'block', width: '100%', marginTop: 14, background: 'none', border: 'none',
  fontSize: 'var(--t-dense)', color: 'var(--teal-500)', fontWeight: 600, cursor: 'pointer',
};

export const lienDiscret: CSSProperties = {
  display: 'block', width: '100%', marginTop: 16, background: 'none', border: 'none',
  fontSize: 'var(--t-dense)', color: 'var(--ink-400)', cursor: 'pointer',
};
